import { useTranslation } from "react-i18next";

import styles from "./style.module.sass";
import { numberWithSpaces, toRubbles } from "../libs";
import { PriceInCurrency } from "../../services/menu/models";
import { useStores } from "../../hooks";

interface IProps {
    label: string,
    item: PriceInCurrency
}

// Подпись задаёт заведение одну на всё меню; бэк отдаёт её только кабинетам с
// включённой фичей, поэтому null здесь = показываем меню по-старому.
export const useOldPriceLabel = (): string | null => {
    const { t, i18n } = useTranslation(["menu"]);
    const { generalMenuStore } = useStores();

    const oldPriceLabel = generalMenuStore.menu?.data?.themeSettings?.oldPriceLabel;
    if (!oldPriceLabel) return null;

    // Заведение могло не перевести подпись на язык гостя — подставляем наш дефолт.
    const label = oldPriceLabel[i18n.language] || t("menu:oldPriceLabel");

    return label && label.trim() !== "" ? label : null;
};

export const OldPriceLabelBadge = ({ label, item }: IProps) => {
    const { t } = useTranslation(["general"]);

    return <div className={styles.badge}>
        <span className={styles.label}>{label}</span>
        <span className={styles.priceContainer}>
            <span className={styles.price}>
                {numberWithSpaces(toRubbles(item.price))}
            </span>
            <span className={styles.currency}>
                {t("general:currency.rub")}
            </span>
            <span className={styles.crossedOverlay}/>
        </span>
    </div>
};

export default OldPriceLabelBadge;
